

export const plantData = [
    {
      commonName: 'Ashwagandha',
      botanicalName: 'Withania Somnifera',
      description: 'Ashwagandha is a powerful adaptogen used in Ayurveda for stress relief, energy boosting, and overall wellness.',
      habitat: 'Native to India, Middle East, and parts of Africa. It thrives in dry regions.',
      medicinalUses: [
        'Stress Relief: Acts as an adaptogen to help the body manage stress.',
        'Energy and Vitality: Boosts energy levels and supports endurance.',
        'Immune Support: Strengthens the immune system and aids in combating infections.'
      ],
      methodsOfCultivation: [
        'Soil Requirements: Prefers sandy and well-drained soil.',
        'Sunlight: Requires full sun exposure.',
        'Watering: Moderate watering; drought-resistant once established.'
      ]
    },
    {
      commonName: 'Tulsi',
      botanicalName: 'Ocimum Sanctum',
      description: 'Tulsi, or Holy Basil, is revered in Ayurveda for its healing properties, particularly for respiratory and immune health.',
      habitat: 'Native to India; grows well in tropical and subtropical climates.',
      medicinalUses: [
        'Respiratory Health: Supports lung health and helps in respiratory infections.',
        'Immune Boost: Strengthens the immune system and fights infections.',
        'Anti-inflammatory: Reduces inflammation and helps in managing joint pain.'
      ],
      methodsOfCultivation: [
        'Soil Requirements: Thrives in well-drained soil with organic matter.',
        'Sunlight: Needs full sun to partial shade.',
        'Watering: Regular watering but avoid overwatering.'
      ]
    },
    {
      commonName: 'Neem',
      botanicalName: 'Azadirachta Indica',
      description: 'Neem is known for its powerful antibacterial and antifungal properties, widely used in skincare and oral care.',
      habitat: 'Native to India and Southeast Asia; thrives in tropical and subtropical climates.',
      medicinalUses: [
        'Skin Health: Treats acne, eczema, and other skin issues.',
        'Oral Care: Helps in maintaining dental hygiene and treating gum infections.',
        'Antibacterial: Acts as a natural disinfectant.'
      ],
      methodsOfCultivation: [
        'Soil Requirements: Grows in a wide variety of soils, including clayey and saline.',
        'Sunlight: Requires full sun exposure.',
        'Watering: Minimal watering; drought-resistant once established.'
      ]
    },
    {
      commonName: 'Amla',
      botanicalName: 'Phyllanthus Emblica',
      description: 'Amla, or Indian Gooseberry, is rich in Vitamin C and antioxidants, used in Ayurveda to boost immunity and improve digestion.',
      habitat: 'Native to India; grows in tropical and subtropical climates.',
      medicinalUses: [
        'Immune Booster: Rich in Vitamin C, enhances immunity.',
        'Digestion: Improves digestion and relieves acidity.',
        'Hair Health: Strengthens hair roots and promotes growth.'
      ],
      methodsOfCultivation: [
        'Soil Requirements: Thrives in well-drained loamy soil.',
        'Sunlight: Needs full sun exposure.',
        'Watering: Moderate watering; avoid waterlogging.'
      ]
    },
    {
      commonName: 'Brahmi',
      botanicalName: 'Bacopa Monnieri',
      description: 'Brahmi is a well-known herb for enhancing cognitive function and improving memory in Ayurveda.',
      habitat: 'Native to India; thrives in wetlands and marshy areas.',
      medicinalUses: [
        'Cognitive Support: Improves memory and brain function.',
        'Stress Relief: Acts as an adaptogen and reduces stress.',
        'Nervous System: Supports the nervous system and helps with anxiety.'
      ],
      methodsOfCultivation: [
        'Soil Requirements: Prefers wet, sandy, and marshy soils.',
        'Sunlight: Requires partial to full sun.',
        'Watering: Needs frequent watering, keeping soil moist.'
      ]
    },
    {
      commonName: 'Shatavari',
      botanicalName: 'Asparagus Racemosus',
      description: 'Shatavari is an adaptogenic herb known for its benefits in women’s health, supporting hormonal balance and reproductive health.',
      habitat: 'Native to India and the Himalayas; grows well in tropical and subtropical regions.',
      medicinalUses: [
        'Women’s Health: Supports hormonal balance and menstrual health.',
        'Reproductive Health: Aids in fertility and overall reproductive wellness.',
        'Digestive Health: Acts as a soothing agent for the digestive system.'
      ],
      methodsOfCultivation: [
        'Soil Requirements: Prefers well-drained, sandy, and loamy soils.',
        'Sunlight: Requires full to partial sun.',
        'Watering: Moderate watering; ensure proper drainage.'
      ]
    }
  ];
  